import React from 'react';
import { components, ValueContainerProps } from 'react-select';
import { locationLine } from 'static/icons/resizable';

export const getCustomValueContainer =
  (includeLocationIcon?: boolean) =>
  <OptionType,>(props: ValueContainerProps<OptionType, false>) => {
    const { children, selectProps, getValue } = props;

    const hasValue = !!getValue()?.length;
    const isInput = !!selectProps.inputValue;

    return (
      <components.ValueContainer {...props}>
        {includeLocationIcon && (hasValue || isInput) && (
          <img
            src={locationLine}
            alt='location icon'
            style={{
              flexShrink: 0,
            }}
          />
        )}
        {children}
      </components.ValueContainer>
    );
  };
